import React from 'react';
import { Navigate } from 'react-router-dom';
import { ApplicationPathName } from '../contexts/constants';
import { useAppSelector } from '../store/hooks';
import { useEnsureEmployeeInfo } from '../hooks/useEnsureEmployeeInfo';

type ProtectedRouteProps = {
  children: React.ReactElement;
};

/**
 * マスタメンテナンス表示可否によるルートガード
 * システム利用設定の「マスタメンテナンス表示」が無効の場合はホーム画面にリダイレクト
 * 別タブ表示等でemployeeInfoが未取得の場合は、useEnsureEmployeeInfoが取得完了するまで待機する
 * （取得中はWebAPIContext側の共通ローディング表示（App.tsx）が出るため、ここでは何も描画しない）
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoading } = useEnsureEmployeeInfo();
  const isMasterMaintenanceAccessible = useAppSelector(state => state.employee.isMasterMaintenanceAccessible);

  if (isLoading) {
    return null;
  }

  if (!isMasterMaintenanceAccessible) {
    return <Navigate to={ApplicationPathName.Home.Url} replace />;
  }

  return children;
};

export default ProtectedRoute;
